import React, { Fragment, useCallback, useState } from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import Switch from '@material-ui/core/Switch'
import Alert from '@material-ui/lab/Alert'
import { StyleSheet, css } from 'aphrodite'
import { AppConfig } from '../../AppConfig'
import { AppHelper } from '../../helpers/AppHelper'
import { Controller } from '../Controller'
import { ApiHelper } from '../helpers/ApiHelper'
import { Helper } from '../helpers/Helper'
import { UiHelper } from '../helpers/UiHelper'
import { PageDialog } from './PageDialog'
import { StaffCheckInDialogContent } from './StaffCheckInDialogContent'

function postStaffMyActivity(iType) {
  const roleHelper = Controller.get().roleHelper()
  const userMgr = Controller.get().userMgr()
  const orgId = roleHelper.getOrgId()
  const org = roleHelper.getOrg()
  const appUser = userMgr.getAppUser()
  if (!orgId || !org || !org.staffId) {
    return Promise.reject(new Error(Helper.getString('internalError')))
  }
  const staffName = appUser ? (Helper.formatName(appUser) || appUser.givenname || appUser.email || '')  : ''
  return ApiHelper.callAwait({
    ms: AppConfig.CDP_MS.ENDPOINT,
    method: 'POST',
    paths: ['miscs', 'my-activity'],
    queryParams: { orgId },
    jsonBody: {
      orgId,
      staffSubOrgId: org.subOrgId || '',
      staffUserId: userMgr.getUserId(),
      staffName,
      staffId: org.staffId,
      iType
    }
  })
}

export function StaffCheckoutDrawerRow(props) {
  const placement = props && props.placement === 'header' ? 'header' : 'drawer'
  const [submitting, setSubmitting] = useState(false)
  const [toast, setToast] = useState({ open: false, msg: '', isError: false })

  const orgId = Controller.get().roleHelper().getOrgId()
  const org = Controller.get().roleHelper().getOrg()
  const enabled = orgId && orgId !== 'PRODUCT' && AppHelper.isSettingEnabled(orgId, 'STAFF_CHECKIN') && org && org.activeStatus && !!org.staffId
  const isActive = org && org.activeStatus === 'ACTIVE'
  const checkInDialogOpen = enabled && !isActive

  const dialogTitle = Helper.getString('staffCheckInDialogTitle').replace(/\{orgLabel\}/g, UiHelper.getMainOrgTitle())

  const runCheckIn = useCallback(() => {
    if (!enabled || submitting) return Promise.resolve()
    setSubmitting(true)
    return postStaffMyActivity('CHECKIN')
      .then(() => {
        window.location.reload()
      })
      .catch((err) => {
        setSubmitting(false)
        setToast({
          open: true,
          msg: Helper.getErrorMsg(err),
          isError: true
        })
        return Promise.reject(err)
      })
  }, [enabled, submitting])

  const onCheckoutSwitchChange = useCallback((event) => {
    if (!enabled || !isActive || submitting) return
    if (event.target.checked) return
    setSubmitting(true)
    postStaffMyActivity('CHECKOUT')
      .then(() => {
        window.location.reload()
      })
      .catch((err) => {
        setSubmitting(false)
        setToast({
          open: true,
          msg: Helper.getErrorMsg(err),
          isError: true
        })
      })
  }, [enabled, isActive, submitting])

  if (!enabled) {
    return null
  }

  const content = (
    <Fragment>
      {isActive && (
        <div className={css(placement === 'header' ? [Styles.row, Styles.rowHeader] : Styles.row)}>
          <span className={css(placement === 'header' ? [Styles.label, Styles.labelHeader] : Styles.label)}>{Helper.getString('staffCheckOut')}</span>
          <Switch
            color='primary'
            checked={!!isActive && !submitting}
            disabled={submitting}
            onChange={onCheckoutSwitchChange}
          />
        </div>
      )}
      {!isActive && (
        <PageDialog
          isOpen={checkInDialogOpen}
          title={dialogTitle}
          preventClose
          fullWidth
          maxWidth='sm'
          PageComponent={StaffCheckInDialogContent}
          PageComponentProps={{
            submitting,
            onCheckIn: runCheckIn
          }}
        />
      )}
      <Snackbar
        open={toast.open}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        onClose={() => setToast(t => ({ ...t, open: false }))}
      >
        <Alert severity={toast.isError ? 'error' : 'success'} onClose={() => setToast(t => ({ ...t, open: false }))}>
          {toast.msg}
        </Alert>
      </Snackbar>
    </Fragment>
  )

  if (placement === 'header') {
    return <div className={css(Styles.headerMount)}>{content}</div>
  }

  return content
}

const Styles = StyleSheet.create({
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 5,
    padding: '0px 30px',
    flexShrink: 0
  },
  rowHeader: {
    justifyContent: 'center',
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 0
  },
  headerMount: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'flex-end',
    justifyContent: 'center',
    minWidth: 0
  },
  label: {
    color: '#7D7D7D',
    fontSize: 14,
    lineHeight: 1.2
  },
  labelHeader: {
    fontSize: 10,
  },
})
